export interface Movie {
  id: number;
  title: string;
  category: string;
  year: number;
  rating: number;
  description: string;
  imageSeq: string;
  genre: string[];
  director: string;
  actors: string[];
  duration: string;
  region: string;
  releaseDate: string;
  isHot: boolean;
  isNew: boolean;
  posterUrl: string;
  heroUrl: string;
  bannerUrl: string;
}

export const categories = [
  { slug: "dianying", name: "电影", icon: "ri-movie-2-line" },
  { slug: "dianshiju", name: "电视剧", icon: "ri-tv-2-line" },
  { slug: "zongyi", name: "综艺", icon: "ri-live-line" },
  { slug: "dongman", name: "动漫", icon: "ri-ancient-gate-line" },
];

export const movies: Movie[] = [
  {
    id: 1,
    title: "流浪地球3",
    category: "dianying",
    year: 2026,
    rating: 8.8,
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，踏上了预计长达2500年的宇宙流浪之旅。面对前所未有的危机，人类展现出惊人的团结与勇气，为生存而战。本片延续前作的宏大叙事，以更加震撼的视觉效果呈现人类在绝境中的抉择与希望。",
    imageSeq: "movie-01-liulang",
    genre: ["科幻", "灾难", "冒险"],
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健"],
    duration: "173分钟",
    region: "中国大陆",
    releaseDate: "2026-02-10",
    isHot: true,
    isNew: false,
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20and%20Earth%20engines%20cinematic%20dramatic%20lighting%20warm%20orange%20tones%20professional%20film%20poster%20design&width=600&height=800&seq=movie-01-liulang&orientation=portrait",
    heroUrl: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20scene%20of%20Earth%20engines%20in%20space%20dramatic%20warm%20lighting%20professional%20film%20photography%20widescreen%20high%20quality&width=1920&height=1080&seq=hero-movie-01-liulang&orientation=landscape",
    bannerUrl: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20banner%20with%20space%20and%20Earth%20engines%20warm%20dramatic%20lighting%20professional%20film%20widescreen&width=1920&height=500&seq=banner-movie-01-liulang&orientation=landscape",
  },
  {
    id: 2,
    title: "哪吒之魔童闹海",
    category: "dongman",
    year: 2025,
    rating: 9.2,
    description: "天劫之后，哪吒和敖丙的灵魂虽保住了，但肉身面临崩解。太乙真人打算用七色宝莲为二人重塑肉身，然而在重塑过程中遇到了重重困难。哪吒与敖丙的命运将走向何方？一场关于成长与勇气的冒险就此展开。",
    imageSeq: "movie-02-nezha",
    genre: ["动画", "奇幻", "冒险"],
    director: "饺子",
    actors: ["吕艳婷", "囧森瑟夫", "瀚墨"],
    duration: "110分钟",
    region: "中国大陆",
    releaseDate: "2025-01-29",
    isHot: true,
    isNew: true,
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%20Nezha%20mythological%20character%20with%20fire%20elements%20cinematic%20dramatic%20lighting%20warm%20red%20and%20gold%20tones%20professional%20film%20poster&width=600&height=800&seq=movie-02-nezha&orientation=portrait",
    heroUrl: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20animation%20scene%20with%20Nezha%20fighting%20fire%20and%20dragon%20dramatic%20warm%20lighting%20professional%20film%20widescreen&width=1920&height=1080&seq=hero-movie-02-nezha&orientation=landscape",
    bannerUrl: "https://readdy.ai/api/search-image?query=Chinese%20mythology%20animated%20movie%20banner%20with%20Nezha%20and%20golden%20elements%20warm%20cinematic%20lighting&width=1920&height=500&seq=banner-movie-02-nezha&orientation=landscape",
  },
  {
    id: 3,
    title: "长安三万里",
    category: "dongman",
    year: 2023,
    rating: 8.3,
    description: "安史之乱后数年，吐蕃大军入侵西南，大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白跨越数十载的情谊，以及那个繁华与诗意交织的大唐盛世。",
    imageSeq: "movie-03-changan",
    genre: ["动画", "历史", "剧情"],
    director: "谢君伟",
    actors: ["杨天翔", "凌振赫", "吴俊全"],
    duration: "168分钟",
    region: "中国大陆",
    releaseDate: "2023-07-08",
    isHot: false,
    isNew: false,
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%20Tang%20Dynasty%20ancient%20China%20poetry%20and%20warriors%20cinematic%20dramatic%20lighting%20warm%20golden%20tones%20professional%20film%20poster&width=600&height=800&seq=movie-03-changan&orientation=portrait",
    heroUrl: "https://readdy.ai/api/search-image?query=Ancient%20Tang%20Dynasty%20China%20animated%20cinematic%20scene%20with%20city%20and%20warriors%20dramatic%20warm%20golden%20lighting%20professional%20film%20widescreen&width=1920&height=1080&seq=hero-movie-03-changan&orientation=landscape",
    bannerUrl: "https://readdy.ai/api/search-image?query=Tang%20Dynasty%20ancient%20Chinese%20city%20banner%20with%20poetic%20and%20warrior%20elements%20warm%20golden%20cinematic%20lighting&width=1920&height=500&seq=banner-movie-03-changan&orientation=landscape",
  },
  {
    id: 4,
    title: "封神第二部：战火西岐",
    category: "dianying",
    year: 2025,
    rating: 7.9,
    description: "殷商大军兵临西岐城下，姜子牙率领西岐军民奋起抵抗。姬发在战火中逐渐成长为一个真正的领袖。神话与战争交织，英雄与命运碰撞，一场关乎天下苍生的世纪之战就此拉开帷幕。",
    imageSeq: "movie-04-fengshen",
    genre: ["奇幻", "动作", "史诗"],
    director: "乌尔善",
    actors: ["黄渤", "费翔", "于适"],
    duration: "148分钟",
    region: "中国大陆",
    releaseDate: "2025-07-18",
    isHot: true,
    isNew: true,
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20epic%20movie%20poster%20with%20ancient%20warriors%20and%20mythological%20creatures%20cinematic%20dramatic%20lighting%20warm%20bronze%20tones%20professional%20film%20poster&width=600&height=800&seq=movie-04-fengshen&orientation=portrait",
    heroUrl: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20battle%20scene%20with%20ancient%20warriors%20and%20mythological%20beasts%20dramatic%20warm%20lighting%20professional%20film%20widescreen&width=1920&height=1080&seq=hero-movie-04-fengshen&orientation=landscape",
    bannerUrl: "https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20banner%20with%20ancient%20warriors%20epic%20battle%20warm%20bronze%20lighting&width=1920&height=500&seq=banner-movie-04-fengshen&orientation=landscape",
  },
  {
    id: 5,
    title: "狂飙",
    category: "dianshiju",
    year: 2023,
    rating: 9.1,
    description: "一部扫黑除恶坚决斗争的回忆录，横跨二十年的群像叙事全景式展现时代变迁下的黑白较量与复杂人性。以安欣为代表的正义力量与以高启强为首的黑恶势力展开一场跨越二十年的较量。",
    imageSeq: "movie-05-kuangbiao",
    genre: ["剧情", "犯罪", "悬疑"],
    director: "徐纪周",
    actors: ["张译", "张颂文", "李一桐"],
    duration: "39集",
    region: "中国大陆",
    releaseDate: "2023-01-14",
    isHot: true,
    isNew: false,
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%20with%20police%20and%20gangster%20atmosphere%20cinematic%20dramatic%20lighting%20warm%20urban%20tones%20professional%20poster&width=600&height=800&seq=movie-05-kuangbiao&orientation=portrait",
    heroUrl: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20cinematic%20scene%20urban%20night%20police%20and%20tension%20dramatic%20warm%20lighting%20professional%20film%20widescreen&width=1920&height=1080&seq=hero-movie-05-kuangbiao&orientation=landscape",
    bannerUrl: "https://readdy.ai/api/search-image?query=Urban%20Chinese%20crime%20drama%20banner%20with%20night%20cityscape%20and%20tension%20warm%20cinematic%20lighting&width=1920&height=500&seq=banner-movie-05-kuangbiao&orientation=landscape",
  },
  {
    id: 6,
    title: "庆余年第二季",
    category: "dianshiju",
    year: 2024,
    rating: 8.5,
    description: "范闲经历了生死考验后回到京都，面对更加复杂的朝堂局势。他与林婉儿之间的感情也面临新的考验。在权力与情感的漩涡中，范闲将如何坚守自己的信念？",
    imageSeq: "movie-06-qingyunian",
    genre: ["古装", "权谋", "爱情"],
    director: "孙皓",
    actors: ["张若昀", "李沁", "陈道明"],
    duration: "36集",
    region: "中国大陆",
    releaseDate: "2024-05-16",
    isHot: true,
    isNew: false,
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20series%20poster%20ancient%20court%20intrigue%20cinematic%20dramatic%20lighting%20warm%20golden%20tones%20professional%20poster&width=600&height=800&seq=movie-06-qingyunian&orientation=portrait",
    heroUrl: "https://readdy.ai/api/search-image?query=Chinese%20ancient%20court%20drama%20cinematic%20scene%20with%20palace%20and%20intrigue%20dramatic%20warm%20golden%20lighting%20professional%20film%20widescreen&width=1920&height=1080&seq=hero-movie-06-qingyunian&orientation=landscape",
    bannerUrl: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20banner%20with%20court%20and%20golden%20elements%20warm%20cinematic%20lighting&width=1920&height=500&seq=banner-movie-06-qingyunian&orientation=landscape",
  },
  {
    id: 7,
    title: "奔跑吧第八季",
    category: "zongyi",
    year: 2024,
    rating: 7.5,
    description: "《奔跑吧》第八季全新升级，明星嘉宾们将在全国各地展开更加刺激有趣的游戏挑战。全新的游戏环节、出人意料的剧情设置、以及嘉宾之间爆笑的互动，为观众带来全新的欢乐体验。",
    imageSeq: "movie-07-benpaoba",
    genre: ["真人秀", "搞笑", "竞技"],
    director: "姚译添",
    actors: ["李晨", "郑恺", "沙溢", "白鹿", "周深", "范丞丞"],
    duration: "12期",
    region: "中国大陆",
    releaseDate: "2024-04-19",
    isHot: false,
    isNew: true,
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20celebrities%20running%20and%20games%20bright%20colorful%20fun%20atmosphere%20warm%20lighting%20professional%20poster&width=600&height=800&seq=movie-07-benpaoba&orientation=portrait",
    heroUrl: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20scene%20with%20celebrities%20playing%20outdoor%20games%20bright%20colorful%20warm%20lighting%20widescreen&width=1920&height=1080&seq=hero-movie-07-benpaoba&orientation=landscape",
    bannerUrl: "https://readdy.ai/api/search-image?query=Bright%20colorful%20variety%20show%20banner%20with%20celebrities%20outdoor%20fun%20games%20warm%20cinematic%20lighting&width=1920&height=500&seq=banner-movie-07-benpaoba&orientation=landscape",
  },
  {
    id: 8,
    title: "奥本海默",
    category: "dianying",
    year: 2023,
    rating: 8.8,
    description: "克里斯托弗·诺兰执导的史诗惊悚片，讲述了理论物理学家罗伯特·奥本海默在二战期间领导曼哈顿计划研制原子弹的故事。影片深入探讨了科学、道德与人性的复杂交织。",
    imageSeq: "movie-08-oppenheimer",
    genre: ["剧情", "传记", "历史"],
    director: "克里斯托弗·诺兰",
    actors: ["基里安·墨菲", "艾米莉·布朗特", "马特·达蒙"],
    duration: "180分钟",
    region: "美国",
    releaseDate: "2023-08-30",
    isHot: false,
    isNew: false,
    posterUrl: "https://readdy.ai/api/search-image?query=Historical%20biopic%20movie%20poster%20with%20atomic%20bomb%20and%20scientist%20cinematic%20dramatic%20lighting%20warm%20vintage%20tones%20professional%20film%20poster&width=600&height=800&seq=movie-08-oppenheimer&orientation=portrait",
    heroUrl: "https://readdy.ai/api/search-image?query=Historical%20drama%20cinematic%20scene%20with%20atomic%20explosion%20and%20scientist%20dramatic%20warm%20vintage%20lighting%20professional%20film%20widescreen&width=1920&height=1080&seq=hero-movie-08-oppenheimer&orientation=landscape",
    bannerUrl: "https://readdy.ai/api/search-image?query=Vintage%20historical%20drama%20movie%20banner%20with%20atomic%20era%20and%20scientist%20warm%20cinematic%20lighting&width=1920&height=500&seq=banner-movie-08-oppenheimer&orientation=landscape",
  },
  {
    id: 9,
    title: "蜘蛛侠：纵横宇宙",
    category: "dongman",
    year: 2023,
    rating: 8.6,
    description: "新生代蜘蛛侠迈尔斯与蜘蛛格温再次展开一场跨越多元宇宙的冒险旅程。面对一个由蜘蛛侠们组成的精英团队和更强大的反派，迈尔斯必须重新思考成为英雄的意义。",
    imageSeq: "movie-09-spiderman",
    genre: ["动画", "动作", "科幻"],
    director: "乔伊姆·多斯·桑托斯",
    actors: ["沙梅克·摩尔", "海莉·斯坦菲尔德", "奥斯卡·伊萨克"],
    duration: "140分钟",
    region: "美国",
    releaseDate: "2023-06-02",
    isHot: false,
    isNew: false,
    posterUrl: "https://readdy.ai/api/search-image?query=Animated%20Spider-Man%20movie%20poster%20with%20multiverse%20and%20comic%20style%20cinematic%20dramatic%20lighting%20warm%20red%20tones%20professional%20film%20poster&width=600&height=800&seq=movie-09-spiderman&orientation=portrait",
    heroUrl: "https://readdy.ai/api/search-image?query=Animated%20Spider-Man%20cinematic%20scene%20with%20multiverse%20and%20urban%20city%20dramatic%20warm%20lighting%20professional%20film%20widescreen&width=1920&height=1080&seq=hero-movie-09-spiderman&orientation=landscape",
    bannerUrl: "https://readdy.ai/api/search-image?query=Animated%20superhero%20movie%20banner%20with%20multiverse%20and%20urban%20comic%20style%20warm%20cinematic%20lighting&width=1920&height=500&seq=banner-movie-09-spiderman&orientation=landscape",
  },
  {
    id: 10,
    title: "热辣滚烫",
    category: "dianying",
    year: 2024,
    rating: 7.8,
    description: "善良的乐莹毕业后一直宅在家里，与外面的世界格格不入。一次偶然的机会让她接触到拳击运动，从此开启了自我蜕变之旅。在挥洒汗水的过程中，她找到了人生的方向与勇气。",
    imageSeq: "movie-10-relaguntang",
    genre: ["剧情", "喜剧", "运动"],
    director: "贾玲",
    actors: ["贾玲", "雷佳音", "张小斐"],
    duration: "129分钟",
    region: "中国大陆",
    releaseDate: "2024-02-10",
    isHot: false,
    isNew: false,
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20with%20boxing%20and%20self-improvement%20cinematic%20dramatic%20lighting%20warm%20hopeful%20tones%20professional%20film%20poster&width=600&height=800&seq=movie-10-relaguntang&orientation=portrait",
    heroUrl: "https://readdy.ai/api/search-image?query=Chinese%20drama%20cinematic%20scene%20with%20boxing%20gym%20and%20determination%20warm%20dramatic%20lighting%20professional%20film%20widescreen&width=1920&height=1080&seq=hero-movie-10-relaguntang&orientation=landscape",
    bannerUrl: "https://readdy.ai/api/search-image?query=Boxing%20gym%20inspirational%20movie%20banner%20with%20warm%20hopeful%20cinematic%20lighting&width=1920&height=500&seq=banner-movie-10-relaguntang&orientation=landscape",
  },
  {
    id: 11,
    title: "三体",
    category: "dianshiju",
    year: 2023,
    rating: 8.3,
    description: "根据刘慈欣同名科幻小说改编。纳米科学家汪淼被警官史强带入一个神秘的组织，揭开了地外文明三体世界的神秘面纱。全人类将面临前所未有的文明危机。",
    imageSeq: "movie-11-santi",
    genre: ["科幻", "悬疑", "剧情"],
    director: "杨磊",
    actors: ["张鲁一", "于和伟", "陈瑾"],
    duration: "30集",
    region: "中国大陆",
    releaseDate: "2023-01-15",
    isHot: false,
    isNew: false,
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20with%20alien%20civilization%20and%20mystery%20cinematic%20dramatic%20lighting%20warm%20cosmic%20tones%20professional%20poster&width=600&height=800&seq=movie-11-santi&orientation=portrait",
    heroUrl: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20cinematic%20scene%20with%20cosmic%20mystery%20and%20alien%20civilization%20dramatic%20warm%20lighting%20professional%20film%20widescreen&width=1920&height=1080&seq=hero-movie-11-santi&orientation=landscape",
    bannerUrl: "https://readdy.ai/api/search-image?query=Cosmic%20sci-fi%20mystery%20banner%20with%20alien%20signals%20and%20space%20warm%20cinematic%20lighting&width=1920&height=500&seq=banner-movie-11-santi&orientation=landscape",
  },
  {
    id: 12,
    title: "向往的生活第八季",
    category: "zongyi",
    year: 2024,
    rating: 8.0,
    description: "《向往的生活》第八季回归田园，主持人和嘉宾们在宁静的乡村中自给自足，招待远道而来的朋友。在远离城市喧嚣的环境中，分享美食与人生故事，传递温暖与治愈。",
    imageSeq: "movie-12-xiangwang",
    genre: ["真人秀", "生活", "美食"],
    director: "王征宇",
    actors: ["黄磊", "何炅", "张艺兴", "彭昱畅", "张子枫"],
    duration: "14期",
    region: "中国大陆",
    releaseDate: "2024-04-26",
    isHot: false,
    isNew: false,
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20reality%20show%20poster%20with%20countryside%20farm%20life%20and%20cooking%20warm%20cozy%20lighting%20professional%20poster&width=600&height=800&seq=movie-12-xiangwang&orientation=portrait",
    heroUrl: "https://readdy.ai/api/search-image?query=Chinese%20countryside%20farm%20life%20scene%20with%20cooking%20and%20nature%20warm%20cozy%20lighting%20widescreen&width=1920&height=1080&seq=hero-movie-12-xiangwang&orientation=landscape",
    bannerUrl: "https://readdy.ai/api/search-image?query=Countryside%20farm%20life%20reality%20show%20banner%20with%20nature%20and%20cooking%20warm%20cozy%20lighting&width=1920&height=500&seq=banner-movie-12-xiangwang&orientation=landscape",
  },
  {
    id: 13,
    title: "满江红",
    category: "dianying",
    year: 2023,
    rating: 7.9,
    description: "南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信不翼而飞。一个小兵和亲兵营副统领机缘巧合被裹挟进这场巨大的阴谋之中。",
    imageSeq: "movie-13-manjianghong",
    genre: ["剧情", "悬疑", "古装"],
    director: "张艺谋",
    actors: ["沈腾", "易烊千玺", "张译"],
    duration: "159分钟",
    region: "中国大陆",
    releaseDate: "2023-01-22",
    isHot: false,
    isNew: false,
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20movie%20poster%20ancient%20Song%20Dynasty%20palace%20intrigue%20cinematic%20dramatic%20lighting%20warm%20red%20tones%20professional%20poster&width=600&height=800&seq=movie-13-manjianghong&orientation=portrait",
    heroUrl: "https://readdy.ai/api/search-image?query=Chinese%20ancient%20palace%20suspense%20cinematic%20scene%20with%20corridor%20and%20shadows%20dramatic%20warm%20lighting%20professional%20film%20widescreen&width=1920&height=1080&seq=hero-movie-13-manjianghong&orientation=landscape",
    bannerUrl: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20suspense%20banner%20with%20corridor%20and%20dramatic%20red%20cinematic%20lighting&width=1920&height=500&seq=banner-movie-13-manjianghong&orientation=landscape",
  },
  {
    id: 14,
    title: "海贼王",
    category: "dongman",
    year: 1999,
    rating: 9.5,
    description: "传奇海盗哥尔·D·罗杰在临刑前留下了一句话：想要我的财宝吗？想要的话可以全部给你，去找吧！我把所有财宝都放在那里。从此，大海贼时代拉开序幕。少年蒙奇·D·路飞怀揣梦想，踏上了寻找ONE PIECE的伟大航路。",
    imageSeq: "movie-14-onepiece",
    genre: ["动画", "冒险", "热血"],
    director: "宇田钢之介",
    actors: ["田中真弓", "中井和哉", "冈村明美"],
    duration: "1000+集",
    region: "日本",
    releaseDate: "1999-10-20",
    isHot: false,
    isNew: false,
    posterUrl: "https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20pirates%20and%20adventure%20on%20the%20sea%20cinematic%20dramatic%20lighting%20warm%20sunset%20tones%20professional%20poster&width=600&height=800&seq=movie-14-onepiece&orientation=portrait",
    heroUrl: "https://readdy.ai/api/search-image?query=Anime%20pirate%20adventure%20cinematic%20scene%20with%20ship%20on%20ocean%20and%20sunset%20dramatic%20warm%20lighting%20professional%20film%20widescreen&width=1920&height=1080&seq=hero-movie-14-onepiece&orientation=landscape",
    bannerUrl: "https://readdy.ai/api/search-image?query=Pirate%20anime%20adventure%20banner%20with%20ship%20and%20ocean%20sunset%20warm%20cinematic%20lighting&width=1920&height=500&seq=banner-movie-14-onepiece&orientation=landscape",
  },
  {
    id: 15,
    title: "歌手2024",
    category: "zongyi",
    year: 2024,
    rating: 7.6,
    description: "《歌手2024》全新升级回归，采用全程直播形式，邀请国内外顶尖歌手同台竞技。真唱真声音，为观众带来最纯粹的音乐盛宴。每一场比赛都是实力的较量，每一个音符都是情感的传递。",
    imageSeq: "movie-15-geshou",
    genre: ["音乐", "竞技", "真人秀"],
    director: "洪啸",
    actors: ["那英", "汪苏泷", "杨丞琳", "海来阿木"],
    duration: "12期",
    region: "中国大陆",
    releaseDate: "2024-05-10",
    isHot: false,
    isNew: true,
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20show%20poster%20with%20singer%20on%20stage%20and%20spotlight%20cinematic%20dramatic%20lighting%20warm%20stage%20tones%20professional%20poster&width=600&height=800&seq=movie-15-geshou&orientation=portrait",
    heroUrl: "https://readdy.ai/api/search-image?query=Music%20competition%20stage%20scene%20with%20singer%20and%20spotlight%20dramatic%20warm%20lighting%20professional%20widescreen&width=1920&height=1080&seq=hero-movie-15-geshou&orientation=landscape",
    bannerUrl: "https://readdy.ai/api/search-image?query=Music%20stage%20performance%20banner%20with%20singer%20and%20spotlight%20warm%20cinematic%20lighting&width=1920&height=500&seq=banner-movie-15-geshou&orientation=landscape",
  },
  {
    id: 16,
    title: "繁花",
    category: "dianshiju",
    year: 2023,
    rating: 8.7,
    description: "九十年代初的上海，处处是机遇与挑战。阿宝凭借自己的智慧与努力，在商海中浮沉起落。从市井小民到风云人物，他的人生轨迹见证了一个时代的变迁。王家卫导演首次执导电视剧，以独特的美学风格再现上海滩的风云变幻。",
    imageSeq: "movie-16-fanhua",
    genre: ["剧情", "爱情", "年代"],
    director: "王家卫",
    actors: ["胡歌", "马伊琍", "唐嫣", "辛芷蕾"],
    duration: "30集",
    region: "中国大陆",
    releaseDate: "2023-12-27",
    isHot: false,
    isNew: false,
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%201990s%20Shanghai%20business%20and%20romance%20cinematic%20dramatic%20lighting%20warm%20golden%20tones%20professional%20poster&width=600&height=800&seq=movie-16-fanhua&orientation=portrait",
    heroUrl: "https://readdy.ai/api/search-image?query=Chinese%201990s%20Shanghai%20period%20drama%20cinematic%20scene%20with%20neon%20lights%20and%20business%20dramatic%20warm%20lighting%20professional%20film%20widescreen&width=1920&height=1080&seq=hero-movie-16-fanhua&orientation=landscape",
    bannerUrl: "https://readdy.ai/api/search-image?query=Vintage%201990s%20Shanghai%20period%20drama%20banner%20with%20neon%20and%20warm%20golden%20cinematic%20lighting&width=1920&height=500&seq=banner-movie-16-fanhua&orientation=landscape",
  },
];